var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.zum.length > 0) ? _vm._l((_vm.zum), function(z) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-zum-' + z.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(z.material.label) + " "), _c('span', [_vm._v(" množství: " + _vm._s(z.amount) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(!_vm.zumPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zum-delete-' + z.id
      },
      on: {
        "click": function($event) {
          _vm.zumPending ? null : _vm.removeZum(z.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa6d99c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListZum.vue
// module id = 523
// module chunks = 0